import { useState, useEffect } from "react";
import { api } from "@/lib/api";

export default function WhatsAppFAB({ plan, name, pincode }) {
  const [href, setHref] = useState("https://wa.me/919819933676");

  useEffect(() => {
    let cancelled = false;
    (async () => {
      try {
        const { data } = await api.post("/whatsapp/booking-message", {
          plan_slug: plan || null,
          name: name || null,
          pincode: pincode || null,
        });
        if (!cancelled) setHref(data.url);
      } catch (err) {
        // keep default href (non-blocking) — log for observability
        console.warn("WhatsApp URL fetch failed, using default:", err?.message);
      }
    })();
    return () => { cancelled = true; };
  }, [plan, name, pincode]);

  return (
    <a
      href={href}
      target="_blank"
      rel="noopener noreferrer"
      className="fixed bottom-5 right-5 md:bottom-8 md:right-8 z-50 flex items-center gap-3 rounded-full bg-[#25D366] text-white pl-4 pr-5 py-3 shadow-xl dd-wa-pulse hover:bg-[#1faa52] transition-colors"
      data-testid="whatsapp-fab"
      aria-label="Chat on WhatsApp"
    >
      <svg viewBox="0 0 32 32" className="w-6 h-6" aria-hidden="true">
        <path fill="currentColor" d="M19.11 17.21c-.3-.15-1.75-.86-2.02-.96-.27-.1-.47-.15-.67.15-.2.3-.77.96-.94 1.16-.17.2-.35.22-.65.07-.3-.15-1.25-.46-2.37-1.47-.88-.78-1.47-1.74-1.64-2.04-.17-.3-.02-.46.13-.6.13-.13.3-.35.45-.52.15-.17.2-.3.3-.5.1-.2.05-.37-.02-.52-.07-.15-.67-1.62-.92-2.22-.24-.58-.49-.5-.67-.51-.17-.01-.37-.01-.57-.01-.2 0-.52.07-.8.37-.27.3-1.05 1.02-1.05 2.5 0 1.47 1.08 2.9 1.23 3.1.15.2 2.12 3.23 5.13 4.53.72.31 1.28.5 1.72.64.72.23 1.37.2 1.89.12.58-.09 1.75-.72 2-1.41.25-.7.25-1.29.17-1.41-.07-.12-.27-.2-.57-.35zM16 3.2C8.93 3.2 3.2 8.93 3.2 16c0 2.26.59 4.38 1.62 6.22L3.2 28.8l6.74-1.77A12.74 12.74 0 0 0 16 28.8C23.07 28.8 28.8 23.07 28.8 16S23.07 3.2 16 3.2zm0 23.4c-1.97 0-3.82-.56-5.38-1.54l-.39-.23-4 1.05 1.07-3.9-.25-.4A10.57 10.57 0 0 1 5.4 16C5.4 10.15 10.15 5.4 16 5.4S26.6 10.15 26.6 16 21.85 26.6 16 26.6z"/>
      </svg>
      <span className="hidden sm:inline font-semibold text-sm">Book on WhatsApp</span>
    </a>
  );
}
